import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'state/store';

export const CacheSelector = (state: RootState) => state.cacheReducer;

export const cacheFamilyPricingDataSelector = createSelector(CacheSelector, (cache) => cache.familyPricingData);
export const cacheCartSelector = createSelector(CacheSelector, (cache) => cache.cart);
export const cacheCartZipCodeSelector = createSelector(CacheSelector, (cache) => cache.cartZipCode);
